import styled from "styled-components";

export const QuestionWrap = styled.li`
     transition: 0.2s;
     @media screen and (max-width: 1140px){
         padding: 0 20px;
     }
`
export const Icon = styled.svg`
    fill: #b9b9b9;
    align-self: center;
    transition: all 0.2s;
    width: 9px;
    height: 17px;
    @media screen and (max-width: 767px){
        margin-right: 10px;
    }
`
export const SummaryButton = styled.button`
    position: relative;
    padding: 18px;
    color: #222;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    background-color: #fdfdfd;
    outline: none;
    border: #ececec 1px solid;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 10px;
    width: 100%;
    transition: all 0.2s;
    box-sizing: border-box;
    &:hover {
        background-color: #f8f8f8;
        ${Icon}{
            fill:#868686;
        }
    }
    @media screen and (max-width: 767px){
        text-align: start;
        display: block;
    }
`

export const ArrowIcon = styled.svg`
    position: absolute;
    top: 50%;
    transform: translateY(-50%) ${({$open})=>$open ? `rotate(90deg)` : ''};
    right: 15px;
    transition: all 0.2s;
    @media screen and (max-width: 767px){
        display: none;
    }
`
export const QuestionContent = styled.div`
    overflow: hidden;
    padding: ${({ $open }) => ($open ? " 20px" : "0 20px")};
    box-sizing: border-box;
    max-height: ${({ $open }) => ($open ? "1000px" : "0")};
    transition: all 300ms ease-in-out;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border:${({ $open }) => ($open ? " #ececec 1px solid" : "#ececec 0px solid")};
`